import { useFieldContext } from "@ark-ui/react";
import { PasswordInput as Password } from "@ark-ui/react/password-input";
import { LuEye, LuEyeOff } from "react-icons/lu";

import { css } from "../../styled-system/css";
import { FormFieldInputStyle, TypographyStyle } from "../common";

export type PasswordInputProperties = Password.InputProps;

export function PasswordInput({ className, style, ...properties }: PasswordInputProperties) {
  const field = useFieldContext();

  return (
    <Password.Root
      className={className}
      disabled={field?.disabled}
      invalid={field?.invalid}
      readOnly={field?.readOnly}
      required={field?.required}
      style={style}
    >
      <Password.Control
        className={css({
          backgroundColor: "white",
          borderRadius: "4px",
          borderColor: "#E4E4E7",
          borderStyle: "solid",
          borderWidth: "1px",
          color: "foreground",
          display: "inline-flex",
          width: "100%",
        })}
      >
        <Password.Input
          className={css(
            TypographyStyle.raw({ lineHeight: 1, monospace: true }),
            FormFieldInputStyle.raw({ border: false, flexGrow: 1 }),
            { minWidth: 0 },
          )}
          {...properties}
        />
        <Password.VisibilityTrigger className={css({ paddingX: "8px" })}>
          <Password.Indicator fallback={<LuEyeOff />}>
            <LuEye />
          </Password.Indicator>
        </Password.VisibilityTrigger>
      </Password.Control>
    </Password.Root>
  );
}
